import { createStore } from 'vuex'
export default createStore({
    state: {
        baseUrlStrapi: 'https://marketing-toolbox.herokuapp.com/',
        baseUrlStrapiApi: 'https://marketing-toolbox.herokuapp.com/api/',
        space: 'h0smdghzpqc3',
        environment: 'master',
        accessToken: 'L5Tw2h-q6liPo6SB6qG0-h6DYTLEnOmSYeFMzuhEQVw',
        username: '',
        AllTools: null,
        AllCategories: null,
        /**
         * UserData
         */
        name: "",
        profilepic: "",
        email: "",
        isLoggedIn: false,
        userObj: {},
        favoriteTools: [],
        currentAddFavTool: {},
        backgroundStartScreen: null,
        loggedInFirebaseUser: null,
        screenMode: 'light',
        screenModeActive: false,
        searchedString: '',
        /**
         * Routing
         */
        routing: {
            startPage: "/",
            homePage: "/Home",
            yungoSite: "https://yungo.be/"
        }
        /**
         *
         */

    },
    mutations: {
        changeLoginStatus(state, isLoggedIn) {
            state.isLoggedIn = isLoggedIn;
        },
        setUserData(state, userObj) {
            state.name = userObj.user.displayName;
            state.profilepic = userObj.user.photoURL;
            state.email = userObj.user.email
            state.userObj = userObj.user.providerData[0];

            localStorage.setItem('userName', state.name);
            localStorage.setItem('profilePic', state.profilepic);
            localStorage.setItem('email', state.email);
            localStorage.setItem('uid', state.userObj.uid);
        },
        setUserFavoriteToolList(state, favTools) {
            favTools !== undefined || favTools.length > 0 ? state.favoriteTools = favTools : state.favoriteTools = state.favoriteTools;
        },
        addTool(state, tool) {
            let arr = state.favoriteTools;
            arr.push(tool);
            state.favoriteTools = arr;

            state.currentAddFavTool = {
                ToolName: tool.title,
                firebaseUserUID: localStorage.getItem('uid')
            }
        },
        removeToolLocally(state, tool) {
           
            tool !== undefined ? state.favoriteTools = state.favoriteTools.filter(x => x.title !== tool.title) : state.favoriteTools = state.favoriteTools;
        },
        removeUserData(state) {
            state.name = "";
            state.profilepic = "";
            state.email = "";
            state.isLoggedIn = false;
            state.favoriteTools = [];

            localStorage.removeItem('userName');
            localStorage.removeItem('profilePic');
            localStorage.removeItem('email');
            localStorage.removeItem('uid');
            localStorage.removeItem('startScreenBackground');
        },
        setBackgroundForStartScreen(state, payload) {
            let bool = false;
            payload !== undefined && payload != null && payload != "null" ? bool = true : null;
            if (bool) {
                state.backgroundStartScreen = payload;
                localStorage.setItem('startScreenBackground', state.backgroundStartScreen);
            }
        },
        setLoggedinFirebaseUser(state, payload) {
            payload !== undefined ? state.loggedInFirebaseUser = payload : null;
        },
        setScreenMode(state, payload) {
            payload !== undefined ? state.screenMode = payload : state.screenMode = 'light';
        },
    },
    actions: {
        async retrieveUserFavoriteTools({ commit, state }) {
            let contentful = require("contentful");
            let client = contentful.createClient({
                space: state.space,
                accessToken: state.accessToken,
            });

            //GET ALL TOOLS
            let arrayOfAllTools = [];
            // gets all the valid tools from api
            client
                .getEntries({
                    content_type: "tool",
                })
                .then(async (entries) => {
                    entries.items.forEach((entry) => {
                        let logo = "";
                        let webprev = "";
                        if (entry.fields.logo !== undefined) {
                            logo = entry.fields.logo.fields.file.url;
                        }
                        if (entry.fields.websitePreview !== undefined) {
                            webprev = entry.fields.websitePreview.fields.file.url;
                        }

                        let obj = {
                            title: entry.fields.title,
                            description: entry.fields.description,
                            category: entry.fields.category,
                            subdivision: entry.fields.subdivision,
                            website: entry.fields.website,
                            logo: logo,
                            websitePreview: webprev,
                            popular: entry.fields.popular
                        };
                        arrayOfAllTools.push(obj);
                    });
                });


            //GET USER FAV TOOLS
            const response = await fetch(
                `${state.baseUrlStrapiApi}favorite-tools`
            );
            let allFavTools = await response.json();
            let ar = [];

            for (let tool of allFavTools.data) {
                let result = arrayOfAllTools.filter(
                    (x) => x.title == tool.attributes.ToolName
                );
                for (let info of result) {
                    if (info !== undefined) {
                        if (
                            tool.attributes.firebaseUserUID === localStorage.getItem("uid")
                        ) {
                            let webprev = "";
                            let logo = "";
                            if (info.logo !== undefined) {
                                logo = info.logo;
                            }
                            if (info.websitePreview !== undefined) {
                                webprev = info.websitePreview;
                            }
                           
                            ar.push({
                                id: tool.id,
                                firebaseUserUID: tool.attributes.firebaseUserUID,
                                title: info.title,
                                description: info.description,
                                category: info.category,
                                subdivision: info.subdivision,
                                website: info.website,
                                logo: logo,
                                websitePreview: webprev,
                                popular: info.popular
                            });
                            commit("setUserFavoriteToolList", ar);
                        }
                    } else {
                        alert("ERROR: Invalid tool");
                    }
                }
            }
        },
        async retrieveUserSelectedBackground({ commit, state }, email) {
            const res = await fetch(`${state.baseUrlStrapiApi}firebase-users`);
            let content = await res.json();
            content = content.data.filter(x => x.attributes.Email == email);
            if (content !== []) {
                commit("setLoggedinFirebaseUser", content);
                if (content[0] === undefined) return;

                commit("setBackgroundForStartScreen", content[0].attributes.BackgroundImageStart);
            }

        },
        async retrieveUserSelectedScreenMode({ commit, state }, email) {
            const res = await fetch(`${state.baseUrlStrapiApi}firebase-users`);
            let content = await res.json();
            content = content.data.filter(x => x.attributes.Email == email);
            if (content !== []) {
                commit("setLoggedinFirebaseUser", content);
                if (content[0] === undefined) return;
                commit("setScreenMode", content[0].attributes.ScreenMode);
            }
        },
        async addTool({ commit, state }, tool) {
            if (tool === undefined) return;
            commit("addTool", tool);
            //Adding at Strapi aswell

            //TODO: Check if firebaseUser existst in api/firebase-users. If not, add it.
            //
            const res = await fetch(`${state.baseUrlStrapiApi}firebase-users`)
            let obj = await res.json();

            //TODO: Check if user with UID exists.
            let exists = obj.data.filter(x => x.attributes.UID == localStorage.getItem("uid"));
            if (obj.data.length <= 0 || exists.length <= 0) {
                //Add the firebaseUser
                let obj2 = {
                    UID: localStorage.getItem('uid'),
                    Email: localStorage.getItem('email'),
                    Name: localStorage.getItem('userName'),
                }
                const rs = await fetch(`${state.baseUrlStrapiApi}firebase-users`, {
                    method: 'POST',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ data: obj2 })
                })
                const content = await rs.json();
            }

            // Create entry
            const rawResponse = await fetch(`${state.baseUrlStrapiApi}favorite-tools`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ data: state.currentAddFavTool })
            });
            const content = await rawResponse.json();
        },
        async removeTool({ commit, dispatch, state }, tool) {
            await dispatch("retrieveUserFavoriteTools");

            setTimeout(async () => {
                tool = state.favoriteTools.filter((x) => x.title === tool.title);
                tool = JSON.parse(JSON.stringify(tool))[0];
                commit("removeToolLocally", tool);
               
                if (tool.id === undefined) {
                    alert('Contact creator with error code [500 UNDEFINED TOOL ID AT DELETION]');
                   
                    return;
                }
                const response = await fetch(`${state.baseUrlStrapiApi}favorite-tools/${tool.id}`, {
                    method: 'DELETE',
                    headers: {
                        'Accept': 'application/json',
                        'Content-type': 'application/json'
                    },
                })
                const content = await response.json();
               

            }, 500)
        },
        async updateUserBackgroundImageStart({ commit, state }, imageUrl) {
            if (imageUrl !== undefined) {
                let obj = {
                    UID: localStorage.getItem('uid'),
                    Email: localStorage.getItem('email'),
                    Name: localStorage.getItem('userName'),
                    BackgroundImageStart: imageUrl
                }
                const response = await fetch(`${state.baseUrlStrapiApi}firebase-users/${state.loggedInFirebaseUser[0].id}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ data: obj })
                })
                const content = await response.json();
            }
        },
        async setScreenModeForUserInStrapi({ commit, state, }, mode) {
            const res = await fetch(`${state.baseUrlStrapiApi}firebase-users`);
            let content = await res.json();
            content = content.data.filter(x => x.attributes.Email == localStorage.getItem('email'));
            if (content !== []) {
                commit("setLoggedinFirebaseUser", content);
                if (content[0] === undefined) return;

                const resp = await fetch(`${state.baseUrlStrapiApi}firebase-users/${state.loggedInFirebaseUser[0].id}`, {
                    method: 'PUT',
                    headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: {
                            UID: localStorage.getItem('uid'),
                            Email: localStorage.getItem('email'),
                            Name: localStorage.getItem('userName'),
                            ScreenMode: mode
                        }
                    })
                })
                const contentres = await resp.json();
            }
        }
    },
    modules: {}
})
